import React from "react";
import { Col, Row } from "react-bootstrap";
import { Outlet } from "react-router-dom";

const ErrorLayout = () => {
  return (
    <Row className="flex-center min-vh-100 py-6">
      <Col sm={11} md={9} lg={7} xl={6} className="col-xxl-5">
        <Outlet />
      </Col>
    </Row>
  );
};

export default ErrorLayout;
